class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    document.addEventListener("menulink:click", (event) => {
      this.show();
    });
  }

  show() {
    setTimeout(() => {
      this.classList.add("state--active");
    }, 50);
  }

  hide() {
    this.classList.remove("state--active");
  }
}

customElements.define("menu-drawer", MenuDrawer);

class MenuOverlay extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("menu-drawer").hide();
    });
  }
}

customElements.define("menu-overlay", MenuOverlay);


class MenuClose extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("menu-drawer").hide();
    });
  }
}

customElements.define("menu-close", MenuClose);
